import { handleErrorException, loading, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getColumnOrderSchema = gridEnum => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GRID_PREFERENCE_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `ColOrderPreference/GetColumnOrderSchema/${gridEnum}`
      );
      dispatch({
        type: types.GRID_PREFERENCE_LIST,
        payload: { [gridEnum]: response.data.Data },
      });
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'Error occurred while fetching grid preference schema',
      };
      dispatch(
        handleErrorException(ex, types.GRID_PREFERENCE_LIST_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.GRID_PREFERENCE_LOADING, false));
    }
  };
};

export const saveColumnOrderSchema = (preferenceJson, Id, tableName) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GRID_PREFERENCE_IS_SUBMITTING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'ColOrderPreference/SaveColumnOrderSchema',
        {
          Id: Id,
          GridDescription: `${tableName}`,
          PreferenceJson: JSON.stringify(preferenceJson),
        }
      );
      dispatch(success(types.GRID_PREFERENCE_SUBMIT));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'Error occurred while saving grid preference schema',
      };
      dispatch(
        handleErrorException(ex, types.GRID_PREFERENCE_SAVE_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.GRID_PREFERENCE_IS_SUBMITTING, false));
    }
  };
};

export const clearGridPreferenceSubmitError = () => {
  return {
    type: types.GRID_PREFERENCE_CLEAR_ERROR,
  };
};

export const clearGridPreference = response => {
  return {
    type: types.CLEAR_GRID_PREFERENCE,
    payload: response,
  };
};



// WEBPACK FOOTER //
// ./src/state/gridPreference/actions.js